<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <Load
        v-if="loading"
        :loading-msg="loadingMsg"
      />
      <v-card-title>
        Cadastro da Escola
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="dataschool.name"
          prepend-icon="mdi-account"
          :error-messages="formError.name"
          label="Nome"
        />
        <v-text-field
          v-model="dataschool.code"
          :error-messages="formError.code"
          prepend-icon="mdi-qrcode"
          label="Código"
        />
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >
            Salvar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Load from '@/components/Loading.vue'

export default {
  name: 'Editschool',

  components: {
    Load
  },

  data: () => ({
    dataschool: {},
    formError: {},
    loading: false
  }),
  created () {
  },
  methods: {
    async onSubmit () {
      const data = this.dataschool
      this.updateschool = false
      try {
        this.loading = true
        this.loadingMsg = 'Salvando...'
        const response = await this.$api.saveSchool(data)
        this.$emit('resolve', response)
      } catch (e) {
        this.formError = e.response.data.errors
      } finally {
        this.loading = false
      }
    },

    onCancel () {
      this.$emit('resolve', false)
    }
  }
}
</script>
